import { Stack, ChoiceGroup } from '@fluentui/react';
import { IGroupConfig } from "../Interfaces"

interface ICustomOperationGroupProps {
    // selectedButtonId: ObservableValue<string>,
    selectedButtonId: string,
    onSelect: (buttonId: string) => void,
    groupConfig: IGroupConfig[]
}

export default function CustomOperationGroup(props: ICustomOperationGroupProps) {
    return (
        <Stack tokens={{ childrenGap: 8 }} className="customCard">
            <div className="flex-row approveOpption" style={{ flexWrap: "wrap" }}>
                <div className="flex-column" role="presentation" aria-hidden="true">
                    <div>The <a href='https://aka.ms/ACCTUserGuide'>Microsoft Automated, Configurable, and Extensible Digital Asset Curation Tool</a> (aka "Sonic") has identified a quality issue in this article and auto-engaged the <a href='https://aka.ms/Autohealing'>Microsoft Digital Asset Self-Healing Tool</a> (aka "Chiron"). Chiron can assist you with quickly resolving this content-quality issue by taking automated actions on your behalf. Please review the options below.
                    </div>
                    {/* <RadioButtonGroup className="flex-grow"
                        selectedButtonId={props.selectedButtonId}
                        onSelect={props.onSelect}
                    >
                        {
                            props.groupConfig.map(item => {
                                return (
                                    <RadioButton disabled={item.disabled} id={item.id} text={item.text} key={item.id} >
                                        { item.child }
                                    </RadioButton>
                                )
                            })
                        }
                    </RadioButtonGroup> */}

                    <ChoiceGroup
                        selectedKey={props.selectedButtonId}
                        onChange={(_, option) => {
                          if (option) {
                            props.onSelect(option.key);
                          }
                        }}
                        options={props.groupConfig.map(item => ({
                            key: item.id,
                            text: item.text,
                            disabled: item.disabled,
                            onRenderField: (prop, render) => (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                    {render!(prop)}
                                    {
                                        props.selectedButtonId == "ManuallyFix" ? item.edittingDiv :
                                            (item.child && <div style={{ marginLeft: 24 }}>{item.child}</div>)
                                    }
                                </div>
                            )
                        }))}
                    />

                </div>
            </div>
            <div className="flex-row" style={{ flexWrap: "wrap", marginTop: "20px" }}>
                <div className="flex-column" >
                    If you have any questions about Sonic, Chiron, or the proposed change above, please click <a style={{ display: "contents" }} href='https://aka.ms/Chironsupport'>here</a> to create a ticket for assistance.
                </div>
            </div>
        </Stack>
    )
}